import { lineDiff } from '../../services/code/lineDiff'
import type { ChangedList } from './codeFiles'

export interface FileDiffLine {
  kind: 'same' | 'added' | 'removed'
  text: string
  oldLine: number | null
  newLine: number | null
}

/** The whole file, with removed lines inserted where they belonged. */
export function fileDiff(before: string, after: string): FileDiffLine[] | null {
  if (before === '' && after === '') return []
  const lines = lineDiff(before, after)
  if (!lines) return null
  // `split('\n')` treats an empty file as one empty line. It is no line.
  if (before === '') {
    const index = lines.findIndex((line) => line.kind === 'mine')
    if (index !== -1) lines.splice(index, 1)
  }
  if (after === '') {
    const index = lines.findIndex((line) => line.kind === 'theirs')
    if (index !== -1) lines.splice(index, 1)
  }
  let oldLine = 0
  let newLine = 0
  return lines.map((line) => {
    if (line.kind === 'mine')
      return {
        kind: 'removed',
        text: line.text,
        oldLine: ++oldLine,
        newLine: null,
      }
    if (line.kind === 'theirs')
      return {
        kind: 'added',
        text: line.text,
        oldLine: null,
        newLine: ++newLine,
      }
    return {
      kind: 'same',
      text: line.text,
      oldLine: ++oldLine,
      newLine: ++newLine,
    }
  })
}

/** Read only the old version of the selected file, at the list's exact base. */
export async function comparisonForFile(
  list: ChangedList,
  path: string,
  after: string | null,
  readBase: (path: string, from: string) => Promise<string | null>,
): Promise<{ from: string; before: string; lines: FileDiffLine[] } | null> {
  const changed = list.files.find((entry) => entry.path === path)
  if (!changed || !list.from) return null
  const before =
    changed.status === 'added'
      ? ''
      : await readBase(changed.oldPath ?? path, list.from)
  if (before === null) return null
  const lines = fileDiff(
    before,
    changed.status === 'deleted' ? '' : (after ?? ''),
  )
  return lines ? { from: list.from, before, lines } : null
}
